import React from 'react'
import { isAndroid, isIOS } from 'react-device-detect'

type Platform = 'android' | 'ios' | 'desktop'

export const usePlatform = () => {
  return isAndroid ? 'android' : isIOS ? 'ios' : 'desktop'
}
